import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Right from '@/images/position/align/Right.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { alignElementsRight } from '../../../../actions/align/Right';

export const RightMenuItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        alignElementsRight(store, selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Right} text="Right" />;
};
